import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from './App';
import './styles.css';
import './test-admin.css';
import './test-admin-pages.css';
import './test-admin-phase3.css';
import './test-admin-phase4.css';
import './test-admin-phase6.css';
import './app-switcher.css';
import './studentLearning.css';

const capacitor = (window as unknown as { Capacitor?: { isNativePlatform?: boolean; Plugins?: { App?: { addListener: (event: string, callback: (data: { url?: string }) => void) => Promise<{ remove: () => void }> } } } }).Capacitor;
if (capacitor?.isNativePlatform && capacitor.Plugins?.App) {
  void capacitor.Plugins.App.addListener('appUrlOpen', ({ url }) => {
    if (!url) return;
    try {
      const target = new URL(url);
      const path = `${target.pathname}${target.search}${target.hash}`;
      if (path && path !== '/') window.history.replaceState({}, '', path);
      window.dispatchEvent(new PopStateEvent('popstate'));
    } catch {
      // Ignore malformed external URLs; the shell remains on the current route.
    }
  });
}

createRoot(document.getElementById('root')!).render(<StrictMode><App /></StrictMode>);
